var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "searcher" },
    [
      _c(
        "v-select",
        {
          staticClass: "imc_reason",
          attrs: {
            label: _vm.get_label_field,
            disabled: _vm.check_if_disabled(),
            searchable: _vm.can_search,
            options: _vm.part_options,
            filterable: false,
          },
          on: { search: _vm.onSearch, input: _vm.on_select_part },
          scopedSlots: _vm._u([
            {
              key: "option",
              fn: function (option) {
                return [
                  _c("div", { staticClass: "d-center" }, [
                    _c("div", [
                      _vm._v(
                        "\n\t\t\t\t\t" + _vm._s(option.name) + "\n\t\t\t\t"
                      ),
                    ]),
                    _vm._v(" "),
                    option.hasOwnProperty("number")
                      ? _c("div", [
                          _c("small", [
                            _vm._v("По заміні :" + _vm._s(option.number)),
                          ]),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", [
                      _c("small", [
                        _vm._v("Оригінал : " + _vm._s(option.numberOriginal)),
                      ]),
                    ]),
                  ]),
                ]
              },
            },
          ]),
          model: {
            value: _vm.part_model,
            callback: function ($$v) {
              _vm.part_model = $$v
            },
            expression: "part_model",
          },
        },
        [
          _c("template", { slot: "no-options" }, [
            _vm._v("\n\t\t\t" + _vm._s(_vm.text_show) + "\n\t\t"),
          ]),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }